export default __webpack_public_path__ + "static/media/send_footer_landing_page.bcf50af6.svg";